import BudgetCalculator from "@/components/budget/BudgetCalculator";
import { useEffect } from "react";
import { getPricingConstants } from "@/components/budget/media-owners";
import { calculateDiscount } from "@/components/budget/utils";

interface BudgetSectionProps {
  devices: number;
  duration: number;
  mediaOwner?: string;
  selectedLocations?: any[];
  "data-budget-total"?: string; // For debugging purposes
}

const BudgetSection = ({ 
  devices, 
  duration, 
  mediaOwner = 'TableAds', 
  selectedLocations = [],
  "data-budget-total": budgetTotal
}: BudgetSectionProps) => {
  
  // Ensure budget is calculated and stored
  useEffect(() => {
    if (devices > 0 && duration > 0) {
      // Get budget calculations if already calculated in another component
      const existingCalculations = localStorage.getItem('budgetCalculations');
      let budgetCalculations;
      
      if (existingCalculations) {
        try {
          budgetCalculations = JSON.parse(existingCalculations);
        } catch (e) {
          console.error('Error parsing existing budget calculations:', e);
          budgetCalculations = null;
        }
      }
      
      // If no existing calculations, create new ones
      if (!budgetCalculations) {
        // Calculate base values
        const costPerDevicePerDay = getPricingConstants(mediaOwner).costPerDevicePerDay;
        const baseTotal = devices * duration * costPerDevicePerDay;
        const discountRate = calculateDiscount(devices, mediaOwner);
        const discountAmount = baseTotal * discountRate;
        const subtotal = baseTotal - discountAmount;
        const VAT_RATE = 0.15; // 15% VAT
        const vatAmount = subtotal * VAT_RATE;
        const totalBudget = subtotal + vatAmount;
        
        // Add performance metrics
        const totalImpressions = Math.round(devices * duration * 100);
        const expectedClicks = Math.round(devices * duration * 3);
        const totalPlaytimes = Math.round(devices * duration * 10);
        
        budgetCalculations = {
          baseTotal,
          discountRate,
          discountAmount,
          subtotal,
          vatAmount,
          totalBudget,
          totalImpressions,
          expectedClicks,
          totalPlaytimes,
          devices,
          duration,
          mediaOwner,
          locations: selectedLocations.length,
          costPerDevicePerDay
        };
        
        // Store the budget calculations in localStorage
        localStorage.setItem('budgetCalculations', JSON.stringify(budgetCalculations));
        console.log('New budget calculations created in BudgetSection:', budgetCalculations);
      }
    }
  }, [devices, duration, mediaOwner, selectedLocations]);
  
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border/40 p-4 sm:p-6">
      <BudgetCalculator 
        devices={devices} 
        duration={duration} 
        mediaOwner={mediaOwner}
        selectedLocations={selectedLocations} 
      />
    </div>
  );
};

export default BudgetSection;
